<template>
  <section  class="item">
    <el-form
      ref="form"
      :model="formData"
      :rules="rules">
      <div class="header">
        <span class="header_title">Product Settings</span>
        <div class="flex">
          <v-button
            gray
            @click="handleCancel"
          >Cancel</v-button>
          <v-button
            v-if="step==1"
            :green="formData.setting!==1"
            :blue="formData.setting==1"
            @click="handleNext"
          >{{ formData.setting==1?'Next':'Save' }}</v-button>
          <template v-else>
            <v-button
              gray
              @click="step=1"
            >Back</v-button>
            <v-button
              green
              @click="handleSave"
            >Save</v-button>
          </template>
        </div>

      </div>
      <template v-if="step==1">
        <div
          class="form-item form-half">
          <span>Settings</span>
          <el-form-item
            ref="setting"
            :rules="rules.select"
            prop="setting">
            <v-radio-group
              v-model="formData.setting"
              block
              :list="product_setting_type"
            />
          </el-form-item>
        </div>
        <template v-if="formData.setting==1">
          <div
            class="form-item form-half">
            <span>Way of Settings</span>
            <el-form-item
              ref="way"
              :rules="rules.way"
              prop="way">
              <v-radio-group
                v-model="formData.way"
                block
                :list="product_setting_way"
              />
            </el-form-item>
          </div>
          <div class="flex-sb-center mg-b-20">
            <p class="fs-14 fw-400">Select the items you <span
              v-if="formData.way==2"
              class="color-red red fs-14">NOT</span> need</p>
            <div>
              <span
                class="blue pointer fs-14 fw-400"
                @click="selectAll">Select All</span>
              <span
                class="blue pointer mg-l-20 fs-14 fw-400"
                @click="clearAll">Clear All</span>
            </div>
          </div>
          <div class="custom-table-container">
            <div
              ref="scrollContainer"
              class="scroll-container">
              <div
                ref="scrollContent"
                class="scroll-content"></div>
            </div>
            <el-table
              ref="table"
              :data="product_company"
              border
              style="width: 100%;"
            >
              <el-table-column
                fixed
                width="215">
                <template #default="{row}">

                  <div class="flex-align-center">
                    <el-checkbox
                      v-model="rowSelected[row.company_id]"
                      @change="selectRow(row.company_id)"
                    />
                    <span class="mg-l-8 fs-14 fw-600 color-dark">{{row.company_name}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-for="(item) in product_classes"
                :key="item.id"
                min-width="158"
              >
                <template slot="header">
                  <span class="flex-sb-center">
                    <span
                      class="blue fs-14 fw-400 pointer"
                      @click="selectColumn(item.id)">Select</span>
                    <span
                      class="blue fs-14 fw-400  pointer"
                      @click="clearColumn(item.id)">Clear</span>
                  </span>
                  <span class="fs-14 fw-600 color-dark">{{item.name}}</span>
                </template>
                <template #default="{row}">
                  <span v-if="categoryies[`${row.company_id}${item.id}`]==1">
                    <v-checkbox v-model="checkboxStates[row.company_id][item.id]"></v-checkbox>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </template>
      <template v-if="step==2">
        <product-setting-display
          ref="product"
          is-edit
          :form="formData"
          :table-data="planList"
          :old-table-data="form.products"
        ></product-setting-display>
      </template>
    </el-form>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {getAccountProductSettingList,getAccountProductSettingPlan,getAccountProductCategorys} from '@api/account'
import ProductSettingDisplay from '@/views/accounts/components/product-setting-display'
import {saveAccountProductSettingList} from '../../../api/account'

export default {
  name: 'product-setting-table',
  components: {ProductSettingDisplay},
  mixins: [MixinOptions,MixinRules],
  props:{
    form:{
      type:Object,
      default:()=>{}
    }
  },
  data(){
    const checkRequired = (rule, value, cb) => {
      let {way} = this.formData||{}
      if(!way||way<=0){
        cb(new Error(this.$t('placeholder.select')))
      }
      cb()
    }
    return {
      showSettingDialog:false,
      isEdit:false,
      formData:{
        setting:'',
        way:'',
      },
      tableData:[],
      step:1,
      checkboxStates: {},
      rowSelected: {},
      planList:[],
      categoryies:{},
      rules: {
        way: [
          {validator: checkRequired, trigger: ['change', 'blur']}
        ],
      }
    }
  },
  computed:{
    customerId(){
      return this.$route.query.customer_id
    },
  },
  watch:{
    form:{
      immediate:true,
      handler(val){
        let {products=[],setting='',way=''} = val||{}
        this.formData.setting = setting
        this.formData.way = way
        this.$nextTick(()=>{
          this.setSelectedProducts(products)
        })
      }
    }
  },
  mounted() {
    this.initCheck()
    this.network().getAccountProductCategorys()
    this.$nextTick(()=>{
      this.syncScroll()
    })
  },
  methods:{
    syncScroll() {
      const tableBodyWrapper = this.$refs.table.$el.querySelector('.el-table__body-wrapper') // 表格内容容器
      const tableBody = this.$refs.table.$el.querySelector('.el-table__body') // 表格内容容器
      const scrollContainer = this.$refs.scrollContainer
      const scrollContent = this.$refs.scrollContent
      // 设置滚动条内容宽度为表格内容宽度
      scrollContent.style.width = `${tableBodyWrapper.scrollWidth}px`

      // 同步滚动事件
      scrollContainer.addEventListener('scroll', () => {
        tableBodyWrapper.scrollLeft = scrollContainer.scrollLeft
      })

      tableBodyWrapper.addEventListener('scroll', () => {
        scrollContainer.scrollLeft = tableBodyWrapper.scrollLeft
      })
    },
    initCheck(){
      this.product_company.forEach(company => {
        this.$set(this.checkboxStates, company.company_id, {})
        this.product_classes.forEach(classItem => {
          this.$set(this.checkboxStates[company.company_id], classItem.id, false)
        })
      })
    },
    // 全选所有单元格
    selectAll() {
      Object.keys(this.checkboxStates).forEach(companyId => {
        Object.keys(this.checkboxStates[companyId]).forEach(classId => {
          this.checkboxStates[companyId][classId] = true
        })
        this.rowSelected[companyId] = true
      })
    },
    // 清除所有单元格
    clearAll() {
      Object.keys(this.checkboxStates).forEach(companyId => {
        Object.keys(this.checkboxStates[companyId]).forEach(classId => {
          this.checkboxStates[companyId][classId] = false
        })
        this.rowSelected[companyId] = false
      })
    },
    selectColumn(classId) {
      Object.keys(this.checkboxStates).forEach(companyId => {
        this.checkboxStates[companyId][classId] = true
      })
      this.updateRowSelectionStates()
    },
    // 清除列
    clearColumn(classId) {
      Object.keys(this.checkboxStates).forEach(companyId => {
        this.checkboxStates[companyId][classId] = false
      })
      this.updateRowSelectionStates()
    },
    selectRow(companyId) {
      const isSelected = this.rowSelected[companyId]
      Object.keys(this.checkboxStates[companyId]).forEach(classId => {
        this.checkboxStates[companyId][classId] = isSelected
      })
    },
    // 更新行选中状态
    updateRowSelection(companyId) {
      const allSelected = Object.values(this.checkboxStates[companyId]).every(val => val)
      this.rowSelected[companyId] = allSelected
    },
    // 更新所有行的选中状态
    updateRowSelectionStates() {
      Object.keys(this.checkboxStates).forEach(companyId => {
        this.updateRowSelection(companyId)
      })
    },
    handleCancel(){
      this.$emit('cancel')
    },
    async handleNext(){
      this.$refs.form.validate(async valid => {
        if(valid) {
          let {setting}  = this.formData||{}
          if(setting!=1){
            await this.network().saveAccountProductSettingList()
          }else {
            await this.network().getAccountProductSettingPlan()
            this.step=2
          }
        }
      })
    },
    handleSave(){
      let {setting}  = this.formData||{}
      let products = this.$refs.product.getProductList()
      this.network().saveAccountProductSettingList({products})
    },
    // 回显接口返回的数据
    setSelectedProducts(products) {
      products.forEach((product) => {
        const { company_id, class_id } = product
        // this.checkboxStates[company_id][class_id] = true
        if (this.checkboxStates[company_id] && this.checkboxStates[company_id][class_id] !== undefined) {
          // 设置单元格为选中状态
          this.checkboxStates[company_id][class_id] = true
        }
      })
      // 更新每行的选中状态
      this.updateRowSelectionStates()
    },
    // 提交选中的数据
    submitSelected() {
      const selectedProducts = []
      Object.keys(this.checkboxStates).forEach(companyId => {
        Object.keys(this.checkboxStates[companyId]).forEach(classId => {
          if (this.checkboxStates[companyId][classId]) {
            selectedProducts.push({
              company_id: parseInt(companyId),
              class_id: parseInt(classId),
              // plan_id: 1 // 如果有多个 plan_id，可以根据需要动态添加
            })
          }
        })
      })
      return selectedProducts
    },
    network(){
      return {
        getAccountProductSettingList: async () => {
          let params = {
            customer_id: this.customerId
          }
          const {data} = await getAccountProductSettingList(params)
          let {list=[],setting='',way=''} = data||{}
          this.formData.setting = setting
          this.formData.way = way
        },
        getAccountProductCategorys: async () => {
          let params = {
          }
          const {data} = await getAccountProductCategorys(params)
          let {categoryies} = data||{}
          this.categoryies = categoryies||{}
        },
        getAccountProductSettingPlan: async (params = {}) => {
          let products = this.submitSelected()
          params ={
            products
          }
          const {data} = await getAccountProductSettingPlan({
            ...params
          })
          let {plans=[]} = data||{}
          this.planList = plans
        },
        saveAccountProductSettingList: async (params = {}) => {
          const {data} = await saveAccountProductSettingList({
            ...this.formData,
            ...params,
            customer_id: this.customerId
          })
          this.$emit('update')
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
.item{
  margin-top: 24px;
  .header{
    display: flex;
    justify-content: space-between;
    .header_title{
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #24292E;
    }
  }
  .table_group{
    margin-top: 20px;
    .table_item{
      .tr{
        background: #FFFFFF;
        border: 1px solid #D1D5DA;
        min-height: 40px;
        display: flex;
        padding: 10px 15px;
        .td{
          flex: 1;
          display: flex;
          //align-items: center;
          font-weight: 400;
          font-size: 14px;
          min-height: 20px;
          color: #24292E;
          &.name{
            //min-width: 280px;
            max-width: 400px;
            word-break: break-word;
            .pct{
              font-weight: 600;
              font-size: 14px;
            }
          }
          &.center{
            flex: 2;
            min-width: 200px;
            justify-content: center;
          }
          &.operation{
            //min-width: 200px;
            justify-content: flex-end;
            color: #0366D6;
            .del{
              color: #CB2431;
            }
            span+span{
              margin-left: 15px;
            }
          }
          .file_name{
            font-weight: 600;
            color: #0366D6;
          }
          .icon{
            //border-radius: 100px;
            //height: 20px;
            //padding: 1px 8px;
            //margin-left: 15px;
            //font-weight: 600;
            //text-align: center;
            //min-width: 70px;
            &.green{
              border: 1px solid #28A745;
              color: #22863A;
            }
            &.gray{
              border: 1px solid #6A737D;
              color: #24292E;
            }
          }
        }
        &.bold{
          background: #F6F8FA;
          .td{
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: #24292E;
          }
        }
        &.empty{
          justify-content: center;
          color: #909399;
          font-size: 14px;
        }
        &.blue_bg{
          background: #F1F8FF;
        }
        &:first-child{
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
        }
        &:last-child{
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
        &+.tr{
          border-top: 0;
        }
      }
    }
    .text-decoration{
      text-decoration:line-through;
    }
    .mg-lr-4{
      margin-left: 4px;
      margin-right: 4px;
    }
    .tips{
      color: #6A737D;
    }
  }
  .icon{
    margin-right: 10px;
    img{
      height: 22px;
      width: 22px;
    }
  }
  .icon-content{
    height: 22px;
    width: 22px;
    border-radius: 5px;
    background-color: #E1E4E8;
    display: block;
    color: #6A737D;
    font-size: 14px;
    text-align: center;
    line-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #e1e4e8;
  }
}
/* 自定义滚动条容器 */
.custom-table-container .scroll-container {
  overflow-x: auto;
  overflow-y: hidden;
  height: 12px; /* 滚动条高度 */
  background: #f5f5f5;
}

/* 空内容，用于撑开滚动条宽度 */
.custom-table-container .scroll-content {
  height: 1px;
}
/* 隐藏表格底部的滚动条 */
.custom-table-container .el-table__body-wrapper {
  overflow-x: hidden !important;
}
/deep/.el-table__body-wrapper {
  //overflow-x: hidden !important;
}
/deep/.el-table__fixed::before {
  height: 0;
}
/* 自定义滚动条 */
/deep/.el-table__body-wrapper::-webkit-scrollbar {
  height: 10px; /* 滚动条的高度 */
  background-color: #eaeaea; /* 滚动条背景色 */
  border-radius: 4px; /* 滚动条背景圆角 */
  width: 80px;
}
.scroll-container::-webkit-scrollbar {
  height: 10px; /* 滚动条的高度 */
  background-color: #eaeaea; /* 滚动条背景色 */
  border-radius: 4px; /* 滚动条背景圆角 */
  width: 80px;
}
*::-webkit-scrollbar {
  width:8px;
  height:8px;
  border-radius: 5px;
  background: #f0f0f0;
}
</style>
